module.exports = __webpack_public_path__ + "static/media/LVFrame12.71820fb5.png";